<video id="remote-screen-video-tag" [class.fullsize]="fullsized" playsinline autoplay muted></video>
